import { defineComponent, PropType } from 'vue'
import './index.scss'
import { BaseCard, GfrContainer, ModuleBase, ModuleBaseHeader } from '#components'
import { moduleBaseProps } from '@/components/module/base'
interface EventItem {
  title: string
  image: string
  publish_time: number
  weight: number
  url: string
  display: number // 前端过滤 0 ｜ 1
}
export default defineComponent({
  name: 'ModuleClEvents',
  props: {
    ...moduleBaseProps,
    title: String,
    list: {
      type: Array as PropType<EventItem[]>,
      default: () => []
    },
    ratio: {
      type: Number,
      default: 16 / 9
    }
  },
  setup(props, { slots }) {
    const eventList = computed(() => {
      return props.list.filter((item) => item.display === 1).sort((a, b) => b.weight - a.weight)
    })
    return () => (
      <ModuleBase name={props.name} class={'module-home-events-base'}>
        <GfrContainer class="module-home-events">
          <ModuleBaseHeader decoration={false} title={props.title} />
          <div class="module-home-events-list">
            {eventList.value.map((item) => (
              <BaseCard
                class="module-home-events-item"
                title={item.title}
                image={item.image}
                url={item.url}
                ratio={props.ratio}
              />
            ))}
          </div>
        </GfrContainer>
      </ModuleBase>
    )
  }
})
